import { createSvgIcon } from "@mui/material/utils";

export default createSvgIcon(
  <path
    d="M12 15C10.3431 15 9 13.6569 9 12C9 10.3431 10.3431 9 12 9C13.6569 9 15 10.3431 15 12C15 12.7956 14.6839 13.5587 14.1213 14.1213C13.5587 14.6839 12.7956 15 12 15Z"
    xmlns="http://www.w3.org/2000/svg"
  />,
  "Dot02S"
);
